import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevronleft--white",
  "use": "icon-chevronleft--white-usage",
  "viewBox": "0 0 24.571 64.423",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24.571 64.423\" id=\"icon-chevronleft--white\">\n<g id=\"icon-chevronleft--white_chevronleft--white\">\n\t<polyline style=\"fill:none;stroke:#FFFFFF;stroke-width:10;stroke-miterlimit:10;\" points=\"20.069,62.247 5.554,32.211 \n\t\t20.069,2.176 \t\" />\n</g>\n<g id=\"icon-chevronleft--white_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol